import React from "react";
import styles from './css/Footer.module.css';

export const Footer = () => {
    return (
        <footer className={styles.footer}>
            <div className={styles.footerContent}>
                <div className={styles.contactInfo}>
                    <h3>צור איתנו קשר:</h3>
                    {/* <p>טלפון: 0544593983</p> */}
                    <p>מייל: <a href="mailto:behavior2026@gmail.com" style={{ color: '#555', textDecoration: 'none' }}>behavior2026@gmail.com</a></p>
                </div>
                <div className={styles.copyright}>
                    © {new Date().getFullYear()} כל הזכויות שמורות
                </div>
            </div>
        </footer>
    );
};
